import { i18n } from '@lingui/core'

import { messages } from './locales/en-GB/messages'

// UK English is the only locale today — see CLAUDE.md. More locales load and activate here later.
i18n.load('en-GB', messages)
i18n.activate('en-GB')

export { i18n }
